import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getStation,postStation, getStationbyId,updateStation,
   deleteStation,updatePartialStation,stationTemplate,importStation,retrieveStation,activateStation
,deactivateStation,verifyAreabyCode,retrieveSubStationsbyCode,retrieveAllStations,
getStationSummary,exportStation,getFacilityType,getFacilityCategory,getLocation,postLocation,updateLocation,exportLocation,
deleteLocation,locationTemplate,importLocation,
getRoutes,exportRoutes,postRoutes,updateRoutes,deleteRoutes,routesTemplate,importRoutes,getRouteGroup,getRouteType} from "../../services/IccMgt/IccServices";
const initialValues = {
  facilityType: [],
  facilityCategory: [],
  routeGroup: [],
  routeType: []
};
let IccStore = (set) => ({
  ...initialValues,
  getStation: async (params) => {
        const response = await getStation(params);
        return response;
      },
      postStation: async (data) => {
        const response = await postStation(data);
        return response;
      },
      getStationbyId: async (data) => { 
        const response = await getStationbyId(data);
        return response;
      },
      updateStation: async (params,data) => {
        const response = await updateStation(params,data);
        return response;
      },
      deleteStation: async (params) => {
        const response = await deleteStation(params);
        return response;
      },
      updatePartialStation: async (params,data) => {
        const response = await updatePartialStation(params,data);
        return response;
      },
      stationTemplate: async () => {
         const response = await stationTemplate();
         return response;
       },
       updatePartialStation: async (params) => {
         const response = await updatePartialStation(params);
         return response;
       },
       importStation: async (params) => {
         const response = await importStation(params);
         return response;
       },
       retrieveStation: async (params) => {
         const response = await retrieveStation(params);
         return response;
       },
       activateStation: async (params) => {
         const response = await activateStation(params);
         return response;
       },
       deactivateStation: async (params) => {
         const response = await deactivateStation(params);
         return response;
       },
       verifyAreabyCode: async (params,data) => {
         const response = await verifyAreabyCode(params,data);
         return response;
       },
       retrieveSubStationsbyCode: async (params) => {
         const response = await retrieveSubStationsbyCode(params);
         return response;
       },
       retrieveAllStations: async (params) => {
         const response = await retrieveAllStations(params);
         return response;
       },
       getStationSummary: async (params) => {
         const response = await getStationSummary(params);
         return response;
       },
       exportStation: async (params) => {
         const response = await exportStation(params);
         return response;
       },
       getFacilityType: async () => {
        const response = await getFacilityType();
        set({ facilityType: response });
        return response;
      },
      getFacilityCategory: async () => {
        const response = await getFacilityCategory();
        set({ facilityCategory: response });
        return response;
      },
      getLocation: async (params) => {
         const response = await getLocation(params);
         return response;
       },
       postLocation: async (params) => {
         const response = await postLocation(params);
         return response;
       },
       updateLocation: async (params,data) => {
         const response = await updateLocation(params,data);
         return response;
       },
       exportLocation: async (params) => {
         const response = await exportLocation(params);
         return response;
       },
       deleteLocation: async (params) => {
        const response = await deleteLocation(params);
        return response;
      },
      locationTemplate: async () => {
        const response = await locationTemplate();
        return response;
      },
      importLocation: async (params) => {
        const response = await importLocation(params);
        return response;
      },
       getRoutes: async (params) => {
        const response = await getRoutes(params);
        return response;
      },
      exportRoutes: async (params) => {
        const response = await exportRoutes(params);
        return response;
      },
      postRoutes: async (params) => {
        const response = await postRoutes(params);
        return response;
      },
      updateRoutes: async (params,data) => {
        const response = await updateRoutes(params,data);
        return response;
      },
      deleteRoutes: async (params) => {
        const response = await deleteRoutes(params);
        return response;
      },
      routesTemplate: async () => {
        const response = await routesTemplate();
        return response;
      },
      importRoutes: async (params) => {
        const response = await importRoutes(params);
        return response;
      },
      getRouteGroup: async () => {
        const response = await getRouteGroup();
        set({ routeGroup: response });
        return response;
      },
      getRouteType: async () => {
        const response = await getRouteType();
        set({ routeType: response });
        return response;
      },
});

IccStore = devtools(IccStore);

export const useIccStore = create(IccStore);